import { SyncLoader } from 'react-spinners'

import { Color } from '../../theme/color'
import type { ColorValues } from '../../theme/color'

interface SpinnerProps {
  size?: number
  color?: ColorValues
}

export function Spinner({ size, color }: SpinnerProps) {
  return <SyncLoader color={color ?? Color.gray_4} size={size ?? 10} />
}
